import { render, staticRenderFns } from "./AssetClass2Picker.vue?vue&type=template&id=5407a2e0&"
import script from "./AssetClass2Picker.vue?vue&type=script&lang=ts&"
export * from "./AssetClass2Picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports